import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d960918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "substandard" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "formBox" }
const _hoisted_4 = {
  key: 0,
  class: "productInfo"
}
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "defectiveReason" }
const _hoisted_7 = { style: {"font-size":"30px"} }
const _hoisted_8 = {
  class: "flex-col",
  style: {"background-color":"#FFF","padding":"20px"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "flex-ter-cen"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { style: {"max-width":"280px","font-size":"11px","padding":"10px"} }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex-ter-cen" }
const _hoisted_15 = {
  class: "historyAdt",
  style: {"width":"520px"}
}
const _hoisted_16 = { class: "hitstoryTitle flex addition" }
const _hoisted_17 = { style: {"width":"160px"} }
const _hoisted_18 = { style: {"width":"120px"} }
const _hoisted_19 = { style: {"width":"120px"} }
const _hoisted_20 = { style: {"width":"120px"} }
const _hoisted_21 = { style: {"width":"160px"} }
const _hoisted_22 = { style: {"width":"120px"} }
const _hoisted_23 = { style: {"width":"120px"} }
const _hoisted_24 = { style: {"width":"120px"} }
const _hoisted_25 = {
  class: "flex-end-aiend priTotal",
  style: {"margin-top":"30px"}
}
const _hoisted_26 = { style: {"color":"red","font-size":"24px"} }
const _hoisted_27 = {
  class: "historyAdt",
  style: {"width":"700px"}
}
const _hoisted_28 = { class: "warning mb_10" }
const _hoisted_29 = { class: "title mb_20" }
const _hoisted_30 = { class: "hitstoryTitle flex" }
const _hoisted_31 = { style: {"width":"240px"} }
const _hoisted_32 = { style: {"width":"150px"} }
const _hoisted_33 = { style: {"width":"240px"} }
const _hoisted_34 = { class: "textEllip" }
const _hoisted_35 = { style: {"width":"150px"} }

import { t, lang } from '@/plugins/i18n'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix, usePlat, useSite2Station, isMultiStore } from '@/store'
import { calc as calcYan, formatCountryMoney, showCurrentUnit } from '@/util/useYan'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import {
  regularizationPage,
  saveReselectBadAddition,
  confirmPayReselectBadAddition,
  regularizationInvalid,
  regularizationRegular
} from '@/apis/stock'
import { getBadAddition } from '@/apis/addition'
import { pageColumns, pageTableConfig, apiConfig, orderProcessResult } from './data'
import STable from '@/components/Table/index.vue'
import TableButton from '@/components/Table/TableButton.vue'
import Processed from './components/processed.vue'
import invalidDialog from './components/invalid.vue'
import PreViewImg from '@/components/common/PreViewImg.vue'
import { QuestionFilled, WarningFilled } from '@element-plus/icons-vue'
import AdtOrder from '@/components/additional/AdtOrder.vue'
import { ElMessage, ElMessageBox } from 'element-plus'

interface processedDataType {
  id: string,
  noAdditionalFlag: number,
  inboundOrderAdditionList: Array<any>
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const closeImg = ref()
closeImg.value = require('@/assets/image/icon/close.svg')

const getCurrencyCode = (country?:string) => {
  // 如果是韩国的商品
  if (country && country === 'KR') {
    return 'KRW'
  }
  return 'CNY'
}

const route = useRoute()
const router = useRouter()
const orderProcessResultList = Object.keys(orderProcessResult).map(v => {
  return {
    label: orderProcessResult[v],
    value: v
  }
})
const params = ref({
  shopProductSku: route.query.shopProductSku,
  platformOrderNo: '',
  orderProcessResult: ''
})
const pageData = ref({
  page: 1,
  limit: 30
})
const productRef = ref()
const search = () => {
  productRef.value && productRef.value.getData()
}

const dataListener = function (records: any, apiData: any) {
  console.log(111111111111, apiData)
  productInfo.value = apiData.data
}
const productInfo = ref({
  defectiveTotal: 0,
  productImg: '',
  productName: '',
  productSku: ''
})

const processedData = ref() as any
const processedVisible = ref(false)
const store = useStore()
const submit = () => {
  const deliveryCountry = processedData.value?.deliveryCountry
  const currencyCode = countryToCurrencyCode[deliveryCountry]
  const parmas = {
    platformOrderNo: processedData.value.platformOrderNo,
    orderNo: processedData.value.orderCode,
    shopProductSku: processedData.value.shopProductSku,
    pkgCode: processedData.value.pkgCode,
    regularOperationName: store.getters.userShops.customerShopName,
    currencyCode: currencyCode,
    goodsCountry: deliveryCountry
  }
  confirmPayReselectBadAddition(parmas).then((res: any) => {
    if (res.code === '0') {
      ElMessage.success({ dangerouslyUseHTMLString: true, message: `<strong>${t('已申请转正品！<br />我们将尽快处理，转正品成功后将有站内信通知到您')}！</strong>` })
      processedVisible.value = false
      productRef.value && productRef.value.getData()
    } else if (res.code === '22010002') {
      showModal('error', {})
    }
  })
}

const showModal = (type: 'success' | 'error' | 'info', data: any) => {
  // 没看到在哪用了这个文案
  const msg1 = data.estimatedTotalOrderPrice === data.totalFreezeAmount ? t('订单已生成，请随时关注订单动态') : t('最新价格为X元').replace('X', data.totalFreezeAmount)
  const success = {
    msg: [
      msg1,
      t('5s后跳转订单详情'),
      t('查看订单详情'),
      t('下单成功')
    ],
    ok: (data: any) => {
      return useRtfix('OrderInfo', {
        params: { id: data.platformOrderId }
      })
    }
  }
  const deliveryCountry = processedData.value?.deliveryCountry
  const currencyCode = countryToCurrencyCode[deliveryCountry]

  const error = {
    msg: [
      t('您的余额不足，请充值后再次支付'),
      t('5s后跳转充值页面'),
      t('去充值'),
      t('')
    ],
    ok: (data: any) =>
      useRtfix('CustomerFund', {
        query: {
        // 跳转需要带上这个币种
          currencyCode: isMultiStore() ? currencyCode : undefined
        }
      })
  }
  const info = {
    msg: [
      t('系统查询到您有辅料未添加到附加项配置'),
      t('5s后跳转附加项配置'),
      t('去配置'),
      t('下单成功')
    ],
    ok: (data: any) =>
      useRtfix('setupShop', {
        query: { type: 'ShopAddition' }
      })
  }
  const { msg, ok } = { success, error, info }[type]

  ElMessageBox.confirm(
    `
          <div class="text-ct">${msg[0]}</div>
          <div class="text-ct">${msg[1]}</div>
          `,
    msg[3],
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: msg[2],
      cancelButtonText: t('回到首页'),
      distinguishCancelAndClose: true,
      customClass: 'stupid-el',
      type
    }
  )
    .then(() => {
      router.push(ok(data))
    })
    .catch((action) => {
      if (action === 'cancel') {
        router.push({ name: usePlat() })
      }
    })
  // 5s后跳转订单详情
  setTimeout(() => {
    const a: any = document.querySelector('.stupid-el')
    if (a) {
      const m = a.parentNode.parentNode
      m.parentNode.removeChild(m)
      router.push(ok(data))
    }
  }, 5000)
}
const process = function (row: processedDataType) {
  if (row.noAdditionalFlag === 2) {
    ElMessage.warning(
      t('请选择附加项后再提交')
    )
    return
  }
  processedData.value = row
  if (row.inboundOrderAdditionList) {
    processedVisible.value = true
  } else {
    submit()
  }
}
const invalidVisable = ref(false)
const invalidArray = ref([])
const pkgInvalid = (row: any) => {
  invalidVisable.value = true
  invalidArray.value = row
  // const params = row.map(item => {
  //   return item.pkgCode
  // })
  // regularizationInvalid(params).then((res: any) => {
  //   if (res.success) {
  //     ElMessage.success({ dangerouslyUseHTMLString: true, message: `<strong>${t('已作废成功')}！</strong><br />共${row.length}个次品` })
  //     productRef.value && productRef.value.getData()
  //   }
  // })
}
const batchInvalid = () => {
  invalidVisable.value = true
  invalidArray.value = selectedData.value
}
const refresh = () => {
  productRef.value && productRef.value.getData()
}
const selectedData = ref([])
const handleSelectionChange = (val: any) => {
  selectedData.value = val
}
// 国家对应的币种
const countryToCurrencyCode:any = {
  CN: 'CNY',
  KR: 'KRW'
}

const toStoreFund = function (row: any) {
  const deliveryCountry = row?.deliveryCountry ?? 'CN'
  const currencyCode = countryToCurrencyCode[deliveryCountry]
  router.push(
    useRtfix('StoreFund', {
      query: {
        platformOrderNo: row.platformOrderNo,
        fundFlowType: 27,
        // 跳转需要带上这个币种
        currencyCode: isMultiStore() ? currencyCode : undefined
      }
    })
  )
}

const proxy: any = ref({})
const additionMerge = ref([])
const historyAdditionMergeList = ref<any[]>([])
const changeAdt = async (goods: any) => {
  const deliveryCountry = goods?.deliveryCountry
  const addtionAsync = await getBadAddition({
    shopProductSku: route.query.shopProductSku,
    platformOrderNo: goods.platformOrderNo,
    productType: goods.productType,
    orderAdditionCode: goods.orderAdditionCode,
    warehouse: goods.warehouse,
    goodsCountry: deliveryCountry
  })
  if (addtionAsync.code === '0') {
    historyAdditionMergeList.value = addtionAsync.data.historyAdditionMergeList
    additionMerge.value = (addtionAsync.data.additionMerge.productAdditionList ? addtionAsync.data.additionMerge.productAdditionList : addtionAsync.data.historyAdditionMergeList).filter((i:any) => ![45, 67].includes(i.additionCode))
    proxy.value = {
      ...goods,
      productPropertiesName: goods.productProp,
      noAdditionalFlag: goods.noAdditionalFlag ? 0 : 1, // 转一下 组件里01是反的
      badAdditionList: addtionAsync.data.reselectAdditionMergeList ?? []
    }
  }
}
const STableRef = ref()
const handleAdt = (res: any) => {
  const params = {
    shopProductSku: route.query.shopProductSku,
    platformOrderNo: proxy.value.platformOrderNo,
    productType: proxy.value.productType,
    pkgCode: proxy.value.pkgCode,
    orderNo: proxy.value.orderCode,
    noAdditionalFlag: 1,
    additionQuantity: proxy.value.defectiveAmount,
    badAdditionList: [],
    goodsCountry: proxy.value.deliveryCountry
  }
  if (res === 1) {
    params.noAdditionalFlag = 0
  } else {
    params.badAdditionList = res
  }
  saveReselectBadAddition(params).then((res: any) => {
    if (res.code === '0') {
      ElMessage.success(
        t('修改成功')
      )
      productRef.value.getData()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('次品处理')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          inline: true,
          model: params.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('所属订单编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: params.value.platformOrderNo,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((params.value.platformOrderNo) = $event)),
                  placeholder: _unref(t)('请输入订单编号'),
                  style: {"width":"300px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('处理状态')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: params.value.orderProcessResult,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((params.value.orderProcessResult) = $event)),
                  style: {"margin-right":"4px","width":"300px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderProcessResultList), (i) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: _unref(t)(i.label),
                        value: i.value,
                        key: i.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { style: {"float":"right"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "warning",
                  onClick: search,
                  style: {}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      (productInfo.value.defectiveTotal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_image, {
              style: {"width":"80px","height":"80px","background-color":"#D8D8D8"},
              src: productInfo.value.productImg,
              fit: "contain",
              "preview-teleported": true
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(productInfo.value.productName), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('平台商品SKU')) + ":" + _toDisplayString(productInfo.value.productSku), 1)
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_unref(t)('次品共')), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(productInfo.value.defectiveTotal), 1),
              _createTextVNode(_toDisplayString(_unref(t)("件")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createVNode(TableButton, {
          class: "batchBtn",
          title: _unref(t)('批量作废'),
          onClick: batchInvalid,
          disabled: !selectedData.value.length,
          style: {"margin-bottom":"10px"}
        }, null, 8, ["title", "disabled"])
      ]),
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['productRef'] = _value
          productRef.value = _value
        },
        api: _unref(regularizationPage),
        apiConfig: _unref(apiConfig),
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => ((pageData).value = $event)),
        columns: _unref(pageColumns),
        tableConfig: _unref(pageTableConfig),
        filterData: params.value,
        onDataListener: dataListener,
        onSelectionChange: handleSelectionChange
      }, {
        defectiveImg: _withCtx(({ row }) => [
          (row.defectiveImgList)
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 0,
                placement: "right-start",
                width: 400,
                trigger: "hover",
                "popper-class": "defectiveImgPop",
                "popper-style": "border:none;border-radius: 8px;box-shadow: 0px 6px 12px 0px #ECECEC;"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    style: {"width":"80px","height":"80px"},
                    src: row.defectiveImgList[0],
                    fit: "contain"
                  }, null, 8, ["src"])
                ]),
                default: _withCtx(() => [
                  _createVNode(PreViewImg, {
                    "img-list": row.defectiveImgList
                  }, null, 8, ["img-list"])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ]),
        addition: _withCtx(({ row }) => [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, _toDisplayString(row.orderProcessResult === 2 ? '-' : row.noAdditionalFlag === 0 ? `${_unref(t)('不需要检品')}` : row.noAdditionalFlag
                ===
                1 ? row.additionNameJp : ''), 1),
            (row.oemProductClassificationId !== 3 && row.orderProcessResult === 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => (changeAdt(row))
                }, _toDisplayString(_unref(t)(`${row.additionName ? '编辑' : '选择附加项' }`)), 9, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ]),
        orderProcessResult: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(orderProcessResult)[row.orderProcessResult] || '-'), 1),
          (row.settleAdditionAmount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(`${ _unref(t)('商品附加项') }：`) + " ", 1),
                _createElementVNode("span", {
                  onClick: ($event: any) => (toStoreFund(row))
                }, [
                  _createElementVNode("a", null, _toDisplayString(`${ row.settleAdditionAmount }${ _unref(isMultiStore)() ? _unref(showCurrentUnit)(row?.deliveryCountry === 'KR'): '' }`), 1)
                ], 8, _hoisted_11),
                _createVNode(_component_el_tooltip, {
                  placement: "top",
                  effect: "light",
                  "popper-class": "orderProcessResultTips"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_unref(t)('次品转正品后，产生的商品附加项费用，可在子钱包（费用流水）页面，使用订单编号查询费用记录，')) + " ", 1),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (toStoreFund(row))
                      }, _toDisplayString(_unref(t)('去查询>')), 9, _hoisted_13)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      color: "#999",
                      style: {"margin-left":"2px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true)
        ]),
        handlerHead: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("操作")), 1)
          ])
        ]),
        handler: _withCtx(({ scope }) => [
          (scope.row.orderProcessResult === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(TableButton, {
                  title: _unref(t)('作废'),
                  onClick: ($event: any) => (pkgInvalid([scope.row]))
                }, null, 8, ["title", "onClick"]),
                _createVNode(TableButton, {
                  title: _unref(t)('转正品'),
                  onClick: ($event: any) => (process(scope.row))
                }, null, 8, ["title", "onClick"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["api", "apiConfig", "page-data", "columns", "tableConfig", "filterData"])
    ]),
    _createVNode(Processed, {
      visible: processedVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((processedVisible).value = $event)),
      processedData: _unref(processedData),
      onSubmit: submit
    }, {
      adtList: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('附加项')), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(`${_unref(t)('价格')}${_unref(isMultiStore)() ? _unref(showCurrentUnit)(_unref(processedData)?.deliveryCountry === 'KR'): ''}`), 1),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('数量')), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(`${_unref(t)('小计')}${_unref(isMultiStore)() ? _unref(showCurrentUnit)(_unref(processedData)?.deliveryCountry === 'KR'): ''}`), 1)
          ]),
          _createVNode(_component_el_scrollbar, { height: "260px" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedData).inboundOrderAdditionList, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "hitstoryItem flex addition",
                  key: i.additionId
                }, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(i.additionNameJp), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(i.cost), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(i.additionQuantity), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(i.subtotal), 1)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("附加项总价")), 1),
            _createElementVNode("span", _hoisted_26, _toDisplayString(`${_unref(processedData).additionTotal}${_unref(isMultiStore)() ? _unref(showCurrentUnit)(_unref(processedData)?.deliveryCountry === 'KR'): ''}`), 1),
            _createElementVNode("span", null, "(" + _toDisplayString(_unref(formatCountryMoney)(_unref(processedData).additionTotal, getCurrencyCode(_unref(processedData).deliveryCountry))) + ")", 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "processedData"]),
    _createVNode(invalidDialog, {
      visible: invalidVisable.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((invalidVisable).value = $event)),
      processedData: invalidArray.value,
      onRefresh: refresh
    }, null, 8, ["visible", "processedData"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value.badAdditionList)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              countryCode: proxy.value.sourceCountry,
              list: proxy.value.badAdditionList,
              "onUpdate:list": _cache[5] || (_cache[5] = ($event: any) => ((proxy.value.badAdditionList) = $event)),
              proxy: proxy.value,
              additionMerge: additionMerge.value,
              "hide-adt-loop": true,
              onCommit: handleAdt,
              type: "AdtOrder",
              title: _unref(t)('选择附加项'),
              noSpot: true
            }, {
              historyAdt: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_icon, { style: {"transform":"rotate(180deg)"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningFilled))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('请重新选择商品附加项，')), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('您之前选择的附加项可能失效或价格发生变化')), 1)
                  ]),
                  (historyAdditionMergeList.value && historyAdditionMergeList.value.length >0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)("历史选择商品附加项")), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('附加项')), 1),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(`${_unref(t)('价格')}${_unref(isMultiStore)() && _unref(processedData)?.deliveryCountry === 'KR' ? _unref(t)('(韩元)'):'（元）'}`), 1)
                        ]),
                        _createVNode(_component_el_scrollbar, { height: "180px" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyAdditionMergeList.value, (i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "hitstoryItem flex",
                                key: i.additionId
                              }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(i.additionNameJp), 1)
                                ]),
                                _createElementVNode("div", _hoisted_35, _toDisplayString(i.cost), 1)
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["countryCode", "list", "proxy", "additionMerge", "title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ]))
}
}

})